import React from 'react';
import { ThemeLoader } from '@sightworks/theme';
import RawAppBarBlock from '../../raw/app-bar/block';

const AppBarBlock = (props, ref) => <RawAppBarBlock ref={ref} {...props}/>;
export default ThemeLoader(AppBarBlock);


